import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

import { ALLOWED_MODULES } from "../../constants/enums";

const ManageCompanyOutlet = Loadable(
	lazy(() =>
		import("./manageCompanyOutlet").then(({ ManageCompanyOutlet }) => ({
			default: ManageCompanyOutlet,
		}))
	)
);

const CompanyOutletList = Loadable(
	lazy(() =>
		import("./companyOutletList").then(({ CompanyOutletList }) => ({
			default: CompanyOutletList,
		}))
	)
);

export const CompanyOutletRoutes = [
	{
		path: "/company-outlet",
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[ALLOWED_MODULES.USERS]}
			>
				<CompanyOutletList />
			</AuthorizedRoute>
		),
	},

	{
		path: "/company-outlet/manage",
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[ALLOWED_MODULES.USERS]}
			>
				<ManageCompanyOutlet />
			</AuthorizedRoute>
		),
	},
	{
		path: "/company-outlet/manage/:uuid",
		exact: true,
		element: (
			<AuthorizedRoute
				allowFullAccess
				moduleIds={[ALLOWED_MODULES.USERS]}
			>
				<ManageCompanyOutlet />
			</AuthorizedRoute>
		),
	},
];
